<template>
  <!-- ARRAY VALUES -->
  <div v-if="this.isArray">
    <div v-for="item in value" v-bind:key="item">
      <form-result-value-display :value="item" />
    </div>
  </div>

  <!-- NON-ARRAY VALUES -->
  <form-result-value-display v-else :value="value" />
</template>

<script>
import FormResultValueDisplay from "./FormResultValueDisplay.vue";

export default {
  name: "FormResultValueField",
  components: {
    FormResultValueDisplay,
  },
  props: {
    value: [String, Array],
  },
  computed: {
    isArray() {
      return _.isArray(this.value);
    },
  },
};
</script>

<style>
.grid-content {
  min-width: 110px;
  min-height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
